import { ReadonlyRefObject, useCallback } from "react";
import { useSynchronizedRef } from "./useSynchronizedRef";

export function useStableImperativeCallback<TActionArguments extends readonly unknown[], TResult>(
	callback: (...args: TActionArguments) => TResult
): ((...args: TActionArguments) => TResult) {
	const callbackRef: ReadonlyRefObject<(...args: TActionArguments) => TResult> = useSynchronizedRef(callback);

	return useCallback(
		(...args: TActionArguments): TResult => {
			return callbackRef.current(...args);
		},
		[callbackRef]
	);
}